import * as React from 'react';
import { ArticleHeading4, ArticleParagraph1 } from '@cian/ui-kit';

import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './NewbuildingLinksList.css';
import { IPromoPopupNewbuildingLink } from '../../types/promosPage';

interface INewbuildingLinksListProps {
  newbuildingCountLink?: string;
  newbuildingCountText: string;
  newbuildingLinks: IPromoPopupNewbuildingLink[];
  onNewbuildingCountLinkClick: () => void;
  onNewbuildingLinkClick: () => void;
}

export const NewbuildingLinksList: React.FC<INewbuildingLinksListProps> = ({
  newbuildingCountLink,
  newbuildingCountText,
  newbuildingLinks,
  onNewbuildingCountLinkClick,
  onNewbuildingLinkClick,
}) => {
  return (
    <>
      {newbuildingCountText && (
        <div className={styles['title']}>
          {newbuildingCountLink ? (
            <a
              href={newbuildingCountLink}
              className={styles['title-link']}
              target="_blank"
              rel="noreferrer"
              onClick={onNewbuildingCountLinkClick}
              data-testid="NewbuildingListLink"
            >
              <ArticleParagraph1 color="primary_100">{newbuildingCountText}</ArticleParagraph1>
            </a>
          ) : (
            <ArticleHeading4 color="black_100">{newbuildingCountText}</ArticleHeading4>
          )}
        </div>
      )}
      <ul className={styles['list']}>
        {newbuildingLinks.map((link, idx) => (
          <li key={idx} className={styles['list-item']}>
            <a
              href={link.url}
              className={styles['link']}
              target="_blank"
              rel="noreferrer"
              onClick={onNewbuildingLinkClick}
              data-testid="NewbuildingListItemLink"
            >
              <ArticleParagraph1>{link.name}</ArticleParagraph1>
              <IconActionChevronRight16 />
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};
